import { Flap } from "@models/Flap";
import ButtonShowcaseScreen from "./ButtonsShowcaseScreen";
import TextInputShowcaseScreen from "./TextInputShowcaseScreen";
import { TabScreenWrapper } from "@components/General/TabScreen";
import { useState } from 'react';
import { } from "@localization/Localization"
import { VerticalMainContainer } from "@components/General/Containers";

export const MainShowcaseScreen: React.FC = () => {
    const [clickedScreen, setClickedScreen] = useState<string>('buttons')

    const flaps: Flap[] = [
        { 
            id: 'buttons', 
            label: 'Buttons'.localized(), 
            content: <ButtonShowcaseScreen/> 
        },
        { 
            id: 'text-inputs', 
            label: 'Text inputs'.localized(), 
            content: <TextInputShowcaseScreen /> 
        },
    ];

    return (
        <VerticalMainContainer>
            <TabScreenWrapper
                title={"Examples".localized()}
                subtitle={"Components available".localized()}
                flaps={flaps}
                clickedScreen={clickedScreen}
                setClickedScreen={setClickedScreen}
            />
        </VerticalMainContainer>
    );

}